<script lang="ts" setup>
defineProps({
  title: {
    type: String,
    default: null,
  },
})
</script>

<template>
  <div class="card-container">
    <h3 v-if="title">{{ title }}</h3>

    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

.card-container {
  background-color: $color-background;
  padding: 1em;
  box-shadow: 0 0 0.25em $color-border;
  border: none;
  border-radius: 0.5em;

  h3:first-child {
    margin-top: 0;
  }

  @media print {
    break-inside: avoid;
    box-shadow: none;
    border: 1px solid $color-border;
  }
}
</style>
